import { Component } from '@angular/core';
import { hotCallDetails } from '../../common/models/hotCall.model';
import { HotCallStatusService } from '../../common/services/hot-call-status.service';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { FilterService } from 'src/app/common/services/filter.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CommonserviceService } from 'src/app/common/services/commonservice.service';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { ErrorHandlerService } from 'src/app/common/services/error-handler.service';
import { GET_CLOSEDHOTCALL } from '../../common/graphql/queries';
import { DatePipe } from '@angular/common';
import { userApplConfigSignal } from 'src/app/common/signals/user-profile-signal';

@Component({
  selector: 'app-closed-hot-calls',
  templateUrl: './closed-hot-calls.component.html',
  styleUrls: ['./closed-hot-calls.component.css'],
  providers: [DatePipe]
})
export class ClosedHotCallsComponent {
  hotCallDetails: hotCallDetails;
  statusClass: string = "";
  closedHotcallForm: FormGroup;
  isLoading: boolean = false;
  sortState: 'normal' | 'asc' | 'desc' = 'normal';
  constructor(
    private readonly fb: FormBuilder,
    private readonly hotCallStatusService: HotCallStatusService,
    private readonly filterService: FilterService,
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly commonsService: CommonserviceService,
    private readonly datePipe: DatePipe,
    private readonly spinner: SpinnerService,
    private readonly errorService: ErrorHandlerService
  ) {
    translate.setDefaultLang('en');
  }

  public filteredHotCalls: hotCallDetails[] = [];
  public closedHotCalls: hotCallDetails[] = [];
  public searchQuery: string = '';
  private readonly searchSubject = new Subject<string>();
  public selectedStatus: string = '';
  public statusOptions: string[] = [];

  ngOnInit(): void {
    this.errorService.clearErrorMessage();
    this.closedHotCalls = [];
    this.filteredHotCalls = [];
    this.spinner.show();
    const plantName = userApplConfigSignal().plantName;
    const shopName = userApplConfigSignal().shopName;
    const lineName = userApplConfigSignal().lineName;
    this.commonsService.getHcmData(GET_CLOSEDHOTCALL, {plantName, shopName, lineName}).subscribe({
      next: (response) => {
        if (response?.data?.getClosedHotCalls?.length) {
          this.closedHotCalls = response.data.getClosedHotCalls;
          this.statusOptions = [...new Set(this.closedHotCalls.map(t => t.ticketStatus))];
          this.filteredHotCalls = this.closedHotCalls;
          this.statusClass = this.hotCallStatusService.getHotCallStatus(this.closedHotCalls[0]?.ticketStatus);
          this.hotCallDetails = this.closedHotCalls[0];
        } else {
          this.closedHotCalls = [];
          this.filteredHotCalls = [];
          this.spinner.hide();
        }
        if (response?.errors) {
          this.spinner.hide();
          this.errorService.setErrorMessage([]);
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      },
      complete: () => {
        this.spinner.hide()
      }
    });

    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.filterHotCalls(searchTerm, this.selectedStatus);
    });
    this.closedHotcallForm = this.fb.group({
      searchQuery: ['',],
      selectedStatus: ['',],
    });
    this.closedHotcallForm.valueChanges.subscribe(values => {
      this.filteredHotCalls = this.filterService.filterHotCalls(values.searchQuery, values.selectedStatus, this.closedHotCalls)

    });
  }

  public filterHotCalls(searchTerm: string, status: string): void {
    this.filteredHotCalls = this.filterService.filterHotCalls(searchTerm, status, this.closedHotCalls);
  }
  public selectHotCall(hotCallLineData: hotCallDetails): void {
    this.statusClass = this.hotCallStatusService.getHotCallStatus(hotCallLineData.ticketStatus);
    this.hotCallDetails = hotCallLineData;
  }

  public getHotCallStatus(status: string): string {
    return this.hotCallStatusService.getHotCallStatus(status);
  }

  public backToHome(): void {
    this.router.navigateByUrl('home')
  }

  public toggleSortOrder(): void {
    const result = this.filterService.toggleSortOrder(this.filteredHotCalls, this.sortState);
    this.filteredHotCalls = result.sortedData;
    this.sortState = result.sortState;
  }
  public getStatus(ticketStatus : string): string{
    return this.hotCallStatusService.getHotCallStatusByCode(ticketStatus);
  }
}
